import styled from 'styled-components';
import { BORDER_RADIUS, Component, Decision, getComponentVariableToken, IconVariant } from '@optimus-web/local-tokens';

const getSupplementaryIconColorToken = getComponentVariableToken(Component.SupplementaryIcon, 'variant');

interface SupplementaryIconElementProps {
    variant: IconVariant;
}

export const SupplementaryIconElement = styled.span<SupplementaryIconElementProps>`
    color: ${getSupplementaryIconColorToken(Decision.Color)};
    background-color: ${getSupplementaryIconColorToken(Decision.BackgroundColor)};
    width: 64px;
    height: 64px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border-radius: ${BORDER_RADIUS['50p']};
`;
